// extracted by mini-css-extract-plugin
module.exports = {"portableText":"BlogHeader_portableText__m_QUa"};